import AnalyticsProvider from "providers/AnalyticsProvider";
import GoogleAnalytics from "components/GoogleAnalytics";
import IntercomProvider from "providers/IntercomProvider";

/**
 * AnalyticsProviders is a wrapper component that includes all analytics-related providers.
 */
function AnalyticsProviders() {
  return (
    <>
      <AnalyticsProvider />
      <GoogleAnalytics />
      <IntercomProvider />
    </>
  );
}

export default AnalyticsProviders;
